import {
	SHOW_SNACKBAR,
	CLOSE_SNACKBAR,
	RELOAD_HEADER,
	LOGIN_MOBILE,
	PROFILE_TAB,
} from './contant'

export const showSnackbar = (open, message, type) => {
	return {
		type: SHOW_SNACKBAR,
		data: {
			open: open,
			content: message,
			severity: type,
		},
	}
}
export const closeSnackbar = data => {
	return {
		type: CLOSE_SNACKBAR,
		data: data,
	}
}
export const reloadHeader = data => {
	return {
		type: RELOAD_HEADER,
		data: data,
	}
}
export const setPhoneLoginMobile = data => {
	return {
		type: LOGIN_MOBILE,
		data: data,
	}
}
export const setProfilePage = data => {
	return {
		type: PROFILE_TAB,
		data: data,
	}
}
